import { render, staticRenderFns } from "./CatalogItems.vue?vue&type=template&id=1d18d78a&scoped=true&"
import script from "./CatalogItems.vue?vue&type=script&lang=js&"
export * from "./CatalogItems.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItems.vue?vue&type=style&index=0&id=1d18d78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18d78a",
  null
  
)

export default component.exports